import { BRAND } from '@mahallu/shared';

/**
 * The Rabita One logo (ADR-0033), from the owner's files in docs/brand/ (never redrawn). `full` is the logo with
 * its tagline (sign-in panel); otherwise the logo without the tagline (side panel, console). `light` is the white
 * version for dark or photo backgrounds; the colour version switches to white in dark mode, where black "Rabita"
 * would vanish.
 */
export function Wordmark({ small, light, full }: { small?: boolean; light?: boolean; full?: boolean }) {
  const cls = `wordmark-img${small ? ' sm' : ''}${full ? ' full' : ''}`;
  const name = full ? 'logo' : 'wordmark';
  const size = full ? { width: 744, height: 180 } : { width: 385, height: 96 };
  const alt = full ? `${BRAND.name} · ${BRAND.tagline}` : BRAND.name;
  // On dark backgrounds: the owner's colour mark with white lettering (docs/brand/rabita-one-*-reverse.png).
  if (light) return <img className={cls} src={`/brand/${name}-reverse.png`} alt={alt} {...size} />;
  return (
    <picture>
      <source srcSet={`/brand/${name}-reverse.png`} media="(prefers-color-scheme: dark)" />
      <img className={cls} src={`/brand/${name}-colour.png`} alt={alt} {...size} />
    </picture>
  );
}

/** Product footer for public pages and printouts: the Rabita One logo with its descriptor. */
export function PoweredBy() {
  return (
    <p className="powered-by">
      <img src="/brand/wordmark-colour.png" alt={BRAND.name} width={385} height={96} />
      <span>{BRAND.descriptor}</span>
    </p>
  );
}
